export default {
  title: 'Sincronizare brand — Branduri',
  subtitle:
    'Prezentare generală a tuturor restaurantelor din grup și a funcțiilor sincronizate. Doar administratorul contului poate face modificări.',
  alert: {
    message: 'Acces doar pentru admin',
    description:
      'Modificările la meniul principal, prețuri și oferte pot fi făcute doar de administratorul contului. Toate locațiile primesc actualizările automat.',
  },
  locations: {
    title: 'Locații',
    description: 'Toate restaurantele din grup care partajează meniul și setările master',
    locations_zero: '0 locații',
    locations_one: '1 locație',
    locations_few: '{{count}} locații',
    locations_other: '{{count}} locații',
    synced: 'Sincronizat',
  },
  features: {
    title: 'Funcții sincronizate',
    description: 'Aceste funcții sunt controlate de setările principale',
    menus: {
      title: 'Meniu principal',
      desription: 'Articolele, categoriile și descrierile meniului sunt sincronizate în toate locațiile',
    },
    smart_pricing: {
      title: 'Prețuri inteligente',
      desription: 'Regulile și ajustările de preț sunt sincronizate în toate locațiile',
    },
    offers: {
      title: 'Oferte și promoții',
      desription: 'Ofertele active, reducerile și promoțiile sunt sincronizate în toate locațiile',
    },
  },
};
